module.exports = __webpack_public_path__ + "static/media/5f8de7ed5ae7590275f074fc_banner_800x600.9840e28c.png";